export default class Reload {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.router.refresh();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/current_location/reload.js